import config from '@/config/config'
import axios from 'axios'

export default {
    state: {
        currentMember: null
    },
    getters: {
        currentMember: state => state.currentMember
    },
    mutations: {
        setMember (state, payload) {
            state.currentMember = payload
        }
    },
    actions: {
        getMemberData ({commit}, cert) {
            commit('setMember', [])
            axios.get(config.apiUrl() + 'member/' + cert).then(response => {
                commit('setMember', response.data)
            }, err => {
                commit('setMember', [])
            })
        }
    }
}
